import React from "react";
import { Sparkles } from "lucide-react";

// Customer-received work photos. Add more entries as new orders come in.
// { image: "/media/customer-xxx.webp", caption: "short one-liner", brand: "dtf" | "sc" }
export const CUSTOMER_PHOTOS = [
  {
    image: "/media/customer-kaskade-tank.webp",
    caption: "Kaskade Redux · Splash House — custom back print on mesh tank",
    brand: "dtf",
  },
  {
    image: "/media/customer-ravers-tank.webp",
    caption: "Los Angeles Ravers — full-color chest print on white mesh tank",
    brand: "dtf",
  },
  {
    image: "/media/customer-soap-sisters.webp",
    caption: "The Soap Sisters — full-color chest print on charcoal tee",
    brand: "dtf",
  },
  {
    image: "/media/customer-powerpuff-tank.webp",
    caption: "Powerpuff-inspired chest graphic on a hot-pink tank",
    brand: "dtf",
  },
  {
    image: "/media/customer-trouble-tee.webp",
    caption: "Double-cat vintage graphic tank — repping the print",
    brand: "dtf",
  },
  {
    image: "/media/customer-noshit-tee.webp",
    caption: "Bold NO SHIT graphic on a safety-orange tee",
    brand: "dtf",
  },
  {
    image: "/media/customer-stickers.webp",
    caption: "DTF Apparel + The Sticky Chick promo stickers, in-hand",
    brand: "sc",
  },
];

const ACCENT = { dtf: "var(--dtf-blue)", sc: "var(--sc-pink)" };

export default function CustomerGallery() {
  if (!CUSTOMER_PHOTOS.length) return null;
  // Duplicate the list so the marquee loop is seamless
  const loop = [...CUSTOMER_PHOTOS, ...CUSTOMER_PHOTOS];
  return (
    <section
      className="border-y-2 border-black bg-white overflow-hidden"
      data-testid="customer-gallery-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-14 md:pt-16">
        <div className="flex items-center gap-3 mb-3">
          <div
            className="w-8 h-8 border border-black inline-flex items-center justify-center"
            style={{ background: "var(--dtf-blue)", color: "#fff" }}
            aria-hidden
          >
            <Sparkles size={14} />
          </div>
          <p className="label-mono">
            CUSTOMER PURCHASED · <span className="text-[color:var(--muted-text)]">real jobs, straight from customers</span>
          </p>
        </div>
        <h2 className="font-display text-4xl md:text-6xl leading-[0.9]">
          IN THE WILD.
        </h2>
      </div>

      <div className="mt-10 pb-14 md:pb-16">
        <div className="cg-track flex gap-5 md:gap-6 px-6 md:px-12 will-change-transform">
          {loop.map((c, i) => (
            <a
              key={i}
              href={c.image}
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0 group border-2 border-black bg-white overflow-hidden"
              style={{
                width: "min(72vw, 340px)",
                boxShadow: `6px 6px 0 0 ${ACCENT[c.brand] || "#000"}`,
              }}
              data-testid={`customer-photo-${i}`}
            >
              <div className="aspect-[3/4] overflow-hidden bg-[color:var(--muted)]">
                <img
                  src={c.image}
                  alt={c.caption}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-3 border-t-2 border-black">
                <p className="label-mono text-[9px]" style={{ color: ACCENT[c.brand] || "#000" }}>
                  {c.brand === "sc" ? "The Sticky Chick" : "Down To Film"}
                </p>
                <p className="font-mono text-xs mt-1 leading-snug">{c.caption}</p>
              </div>
            </a>
          ))}
        </div>
      </div>

      <style>{`
        .cg-track {
          animation: cg-scroll 40s linear infinite;
        }
        .cg-track:hover { animation-play-state: paused; }
        @keyframes cg-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .cg-track { animation: none; }
        }
      `}</style>
    </section>
  );
}
